import React from 'react';

import type { Status } from '@vlabs/api/artemy/model';
import { Tag } from '@vlabs/uikit';

import { useUserDetailsPageTranslation } from '../i18n';

const StatusKindMap = {
  active: 'positive',
  pending: 'neutral',
  blocked: 'negative',
} as const;

interface UserStatusTagProps {
  status?: Status;
}

function UserStatusTag({
  status = undefined,
}: UserStatusTagProps): React.JSX.Element | null {
  const { t } = useUserDetailsPageTranslation();

  if (!status) return null;

  return (
    <Tag
      kind={StatusKindMap[status]}
      shape="square"
      value={t(status)}
    />
  );
}

export { UserStatusTag };
